import { AgentProtocol, AgentOutput } from './types';

export class PricingAgent implements AgentProtocol {
    role = 'Pricing Strategist';

    async process(context: {
        opportunity: any;
        userStack: string;
        contractorName: string;
    }): Promise<AgentOutput> {
        const { opportunity, userStack, contractorName } = context;

        const prompt = `
            ROLE: Government Pricing & Competitive Intelligence Strategist for ${contractorName}.
            TASK: Assess pricing strategy and potential level of effort for a government contract.
            USER STACK: ${userStack}
            REQ TITLE: ${opportunity.title}
            REQ DESC: ${opportunity.description?.substring(0, 1500)}...
            
            Analyze:
            1. Estimate the complexity Level of Effort (LOE).
            2. Suggest a strategic pricing approach based on the scope.
            
            Output JSON: { "score": 0-100, "recommendation": "GO/NO-GO/REVIEW", "reasoning": "A short summary", "findings": ["Major Point 1", "Point 2"], "confidence": 0-1 }
        `;

        try {
            const { httpsCallable } = await import('firebase/functions');
            const { functions } = await import('../firebase');
            const analyzeOpportunity = httpsCallable(functions, 'analyzeOpportunity');

            const result = await analyzeOpportunity({
                prompt: prompt,
                context: opportunity
            });

            const data = result.data as any;
            const text = data.result || data.candidates?.[0]?.content?.parts?.[0]?.text || "{}";
            const json = JSON.parse(text.replace(/```json/g, '').replace(/```/g, '').trim());

            return {
                role: this.role,
                summary: json.reasoning || "Pricing strategy generated.",
                score: json.score || 50,
                findings: json.findings || [],
                recommendation: json.recommendation || "REVIEW",
                confidence: json.confidence || 0.5,
                reasoning: json.reasoning || "Price modeling complete."
            };
        } catch (e) {
            console.error("Pricing Agent Error", e);
            return {
                role: this.role,
                summary: "Pricing analysis failed.",
                score: 0,
                findings: ["System Error in LLM pipeline"],
                recommendation: "ERROR",
                confidence: 0,
                reasoning: "The pricing agent encountered an internal error."
            };
        }
    }
}
